export default __webpack_public_path__ + "static/media/binanceWallet.6015b9f4.svg";